import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Avatar,
  Chip,
} from '@mui/material';
import Carousel from 'react-material-ui-carousel';
import WavingHandIcon from '@mui/icons-material/WavingHand';
import WorkIcon from '@mui/icons-material/Work';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

export const NewJoinersSection = () => {
  const newJoiners = [
    {
      name: 'Olivia Martinez',
      role: 'Senior Product Manager',
      department: 'Product & Technology',
      joinDate: 'Dec 1, 2025',
      bio: 'Bringing 8 years of experience in SaaS product development',
      color: '#667eea',
    },
    {
      name: 'Ethan Cooper',
      role: 'Marketing Specialist',
      department: 'Marketing & Growth',
      joinDate: 'Dec 5, 2025',
      bio: 'Expert in digital marketing and brand strategy',
      color: '#10b981',
    },
    {
      name: 'Sophia Zhang',
      role: 'Full Stack Developer',
      department: 'Product & Technology',
      joinDate: 'Dec 8, 2025',
      bio: 'Passionate about building scalable web applications',
      color: '#f59e0b',
    },
    {
      name: 'Liam Patel',
      role: 'Data Scientist',
      department: 'Data & Analytics',
      joinDate: 'Dec 10, 2025',
      bio: 'Specializing in machine learning and predictive analytics',
      color: '#ec4899',
    },
    {
      name: 'Emma Thompson',
      role: 'UX Designer',
      department: 'Product & Technology',
      joinDate: 'Dec 12, 2025',
      bio: 'Creating delightful user experiences through design',
      color: '#8b5cf6',
    },
  ];

  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #0a1a21 0%, #2a4d5c 100%)',
        py: 10,
      }}
    >
      <Container maxWidth="md">
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <WavingHandIcon sx={{ fontSize: 60, color: '#ffd700', mb: 2 }} />
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              color: '#fff',
              mb: 2,
              textShadow: '0 2px 10px rgba(0,0,0,0.3)',
            }}
          >
            Welcome New Team Members!
          </Typography>
          <Typography variant="h6" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
            We're excited to have you join the Orunal family
          </Typography>
        </Box>

        <Carousel
          indicators={true}
          navButtonsAlwaysVisible={true}
          autoPlay={true}
          interval={4000}
          animation="slide"
          sx={{
            '& .MuiIconButton-root': {
              color: '#fff',
              bgcolor: 'rgba(255, 255, 255, 0.2)',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.3)',
              },
            },
          }}
        >
          {newJoiners.map((joiner, index) => (
            <Paper
              key={index}
              elevation={6}
              sx={{
                p: 5,
                borderRadius: 4,
                textAlign: 'center',
                background: `linear-gradient(135deg, ${joiner.color}22 0%, #fff 100%)`,
                border: `2px solid ${joiner.color}`,
                minHeight: 350,
              }}
            >
              {/* Avatar */}
              <Avatar
                sx={{
                  width: 120,
                  height: 120,
                  mx: 'auto',
                  mb: 3,
                  bgcolor: joiner.color,
                  color: '#fff',
                  fontSize: '3rem',
                  fontWeight: 700,
                  boxShadow: 3,
                }}
              >
                {joiner.name.charAt(0)}
              </Avatar>

              {/* Name */}
              <Typography
                variant="h4"
                sx={{ fontWeight: 700, mb: 1, color: '#1a1a1a' }}
              >
                {joiner.name}
              </Typography>

              {/* Role */}
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
                <WorkIcon sx={{ fontSize: 20, color: joiner.color, mr: 1 }} />
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#333' }}>
                  {joiner.role}
                </Typography>
              </Box>

              {/* Department */}
              <Chip
                label={joiner.department}
                sx={{
                  mb: 2,
                  bgcolor: joiner.color,
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '0.9rem',
                }}
              />

              {/* Join Date */}
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
                <CalendarTodayIcon sx={{ fontSize: 18, color: '#666', mr: 1 }} />
                <Typography variant="body2" sx={{ color: '#666', fontWeight: 600 }}>
                  Joined on {joiner.joinDate}
                </Typography>
              </Box>

              {/* Bio */}
              <Typography
                variant="body1"
                sx={{
                  color: '#555',
                  fontStyle: 'italic',
                  mt: 2,
                  px: 3,
                }}
              >
                "{joiner.bio}"
              </Typography>
            </Paper>
          ))}
        </Carousel>
      </Container>
    </Box>
  );
};

export default NewJoinersSection;